import stock from '@/api/stock';
import * as types from './mutationTypes';

export default {
  searchKeywords({ commit }, payload) {
    commit(types.START_SEARCH_KEYWORDS, payload.input);

    return stock.getStockKeywords(
      payload,
    ).then((keywords) => {
      commit(types.SET_SEARCH_KEYWORDS, keywords);
    }).catch((e) => {
      commit(types.SEARCH_KEYWORDS_ERROR, `failed get stocks: ${e}`);
    });
  },

  changeInput({ commit }, input) {
    commit(types.CHANGE_INPUT, input);
  },

  addKeyword({ commit }, keyword) {
    commit(types.ADD_KEYWORD, keyword);
  },

  removeKeyword({ commit }, keyword) {
    commit(types.REMOVE_KEYWORD, keyword);
  },

  setKeywords({ commit }, keyword) {
    const keywordsList = JSON.parse(`[${keyword}]`);
    const processedList = [];
    keywordsList.forEach(data => processedList.push(`{"suggestionWord":"${data.suggestionWord}","type":"${data.type}","value":"${data.value}","ics":"${data.ics}"}`));
    commit(types.SET_KEYWORDS, processedList);
  },

  unsetKeywords({ commit }) {
    commit(types.UNSET_KEYWORDS);
  },
};
